import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  phoneNumber: {
    id: 't.app.terminalsManagement.disputeless.form.phoneNumber',
    defaultMessage: 'Phone number*'
  },
  countryCode: {
    id: 't.app.terminalsManagement.disputeless.form.countryCode',
    defaultMessage: 'Country code*'
  },
  select: {
    id: 't.app.project.placeholder.select',
    defaultMessage: 'Select'
  },
  enterNumber: {
    id: 't.app.project.placeholder.enterNumber',
    defaultMessage: 'Enter number'
  }
})
